import { i18n } from '@lt/localization';

import type { SortType } from './types';

export const CHANGE_SORTING = 'CHANGE_SORTING';
// По возрастанию
export const ORDER_ASC = 'asc';
// По убыванию
export const ORDER_DESC = 'desc';

// Типы сортировок
export const SORT_TYPES: SortType[] = [
  {
    id: 'relevance',
    label: i18n.t('search.sorting.relevance.label'),
    types: [
      {
        label: i18n.t('search.sorting.relevance.show'),
        order: null,
      },
    ],
  },
  {
    id: 'price',
    label: i18n.t('search.sorting.price.label'),
    types: [
      {
        label: i18n.t('search.sorting.price.cheap'),
        order: ORDER_ASC,
      },
      {
        label: i18n.t('search.sorting.price.expensive'),
        order: ORDER_DESC,
      },
    ],
  },
  {
    id: 'rating',
    label: i18n.t('search.sorting.rating.label'),
    types: [
      {
        label: i18n.t('search.sorting.rating.show'),
        order: ORDER_DESC,
      },
    ],
  },
];
